export const PARTICLES_CONFIG = {
  uRandom: {
    min: 1,
    // max: 21.33
    max: 30
  },
  uDepth: {
    min: 12,
    max: 10,
  },
  uSize: {
    min: 0.20,
    max: 0.20,
  },
  uCurl: {
    min: 0,
    // max: 0.67,
    // max: 0.0067,
    max: 5,
  },
  uContrast: {
    min: 1
  },
  uScale: {
    min: 1
  }
};

// export const QUESTIONS_COUNT = 1;
export const QUESTIONS_COUNT = 7;

export const INTRO_SPRITE_SRC = `./../img/intro-sprite-${LANG}.jpg`;

export const INTRO_SPITE_CONFIG = {
  size: {
    width: 328,
    height: 820,
  },
  count: 110,
};

export const FACE_TRANSITION_CONST = {
  randomMax: 30,
  randomMin: 1,
  depthMax: 0,
  depthMin: 20,
};

export const FACE_TRANSITION_PHASES = [
  {
    random: 1,
    curl: 0,
    scale: 1,
    size: 0.6,
    contrast: 1,
  },
  {
    random: 5,
    curl: 1.4,
    scale: 0.45,
    size: 0.7,
    contrast: 1,
  },
  {
    random: 10,
    curl: 2.05,
    scale: 0.5,
    size: 0.7,
    contrast: 1,
  },
  {
    random: 15,
    curl: 2.5,
    scale: 0.55,
    size: 0.7,
    contrast: 1,
  },
  {
    random: 14,
    curl: 8,
    scale: 0.31,
    size: 0.84,
    contrast: 0.71,
  },
  {
    random: 20,
    curl: 3.05,
    scale: 0.65,
    size: 0.70,
    contrast: 1,
  },
  {
    random: 25,
    curl: 3.50,
    scale: 0.8,
    size: 0.7,
    contrast: 1,
  },
  {
    random: 30,
    curl: 5,
    scale: 1,
    size: 0.7,
    contrast: 1,
  }
];

